import { autoinject, bindable, observable } from "aurelia-framework";
import { IWordTemplateAM, ReportService } from "./report-api";
import { NotificationType, ResourcedNotificationService } from "../../components/notifications/notification-service";
import { ReportingStateService } from "./reporting-state-service";

@autoinject
export class ReportWordExportDialog {
	private wordTemplateSelectElement: HTMLSelectElement;
	
	@bindable customerId: string;
	
	@observable wordTemplates: IWordTemplateAM[];
	@observable reportName: string;
	@observable reportId: string;
	@observable isFolder: boolean;

	// Selected WordTemplateId  - empty guid is non-customer specific default template
	@observable selectedWordTemplateId: string | "00000000-0000-0000-0000-000000000000" = "00000000-0000-0000-0000-000000000000";
	
	constructor(private api: ReportService, private reportingStateService: ReportingStateService, private notificationService: ResourcedNotificationService) { }
	
	async attached() {
		await this.fetchCustomerWordTemplates();
	}

	async fetchCustomerWordTemplates() {
		if (this.customerId) {
			const res = await this.api.getCustomerWordTemplates(this.customerId);
			this.wordTemplates = res;
			this.selectedWordTemplateId = res.length > 0 ? res[0].id : "00000000-0000-0000-0000-000000000000";
		}
	}
	
	openDialog() {
		const { name, id, isFolder } = this.reportingStateService.getReportToExport();
		
		this.reportName = name;
		this.reportId = id;
		this.isFolder = isFolder;

		// Reset select dialog, if templates are available.
		// We want to do this here (when opening the dialog, instead of when closing it), because
		// when exporting to Word the selection is then changed before making the API call causing wrong
		// template to be selected for export.
		if (this.wordTemplateSelectElement) {
			this.wordTemplateSelectElement.selectedIndex = 0;
			this.selectedWordTemplateId = this.wordTemplates.length > 0
				? this.wordTemplates[0].id
		  		: "00000000-0000-0000-0000-000000000000";
		}
		
		// Workaround for TS6385: HTMLDialogElement is deprecated
		const elem = document.querySelector("#exportDialog") as HTMLDialogElement;
		if (elem) {
			(elem as any).showModal();
		}
	}

	closeDialog() {
		// Workaround for TS6385: HTMLDialogElement is deprecated
		const elem = document.querySelector("#exportDialog") as HTMLDialogElement;
		if (elem) {
			(elem as any).close();
			this.reportingStateService.removeReportToExport();
		}
	}

	exportToWord() {
		this.closeDialog();
		this.notificationService.push("Reports_WordExportDialog_ExportStarted", NotificationType.Info);

		// Return true to allow default event handling
		return true;
	}
}
